import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

export default function RaceAttendes() {
	const { id } = useParams();
	const [attendees, setAttendees] = useState([]);
	const [hotels, setHotels] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const token = localStorage.getItem('token');
		setLoading(true);
		Promise.all([
			fetch(`/api/races/${id}/attendees`, { headers: { Authorization: `Bearer ${token}` } }).then(res => res.json()),
			fetch(`/api/races/${id}/hotels`, { headers: { Authorization: `Bearer ${token}` } }).then(res => res.json()),
		])
			.then(([att, h]) => { setAttendees(att || []); setHotels(h || []); setLoading(false); })
			.catch(() => setLoading(false));
	}, [id]);

	if (loading) return <div className="p-6">Loading attendees...</div>;

	if (!Array.isArray(attendees)) return <div className="p-6">Failed to load attendees</div>;

	// Build map of userId -> hotels[]
	const hotelsByUser = {};
	(hotels || []).forEach(h => {
		if (!h || !h.user_id) return;
		hotelsByUser[h.user_id] = hotelsByUser[h.user_id] || [];
		hotelsByUser[h.user_id].push(h);
	});

	const formatDate = (d) => {
		if (!d) return '-';
		try { return new Date(d).toLocaleString(); } catch { return d; }
	};

	return (
		<div className="p-6">
			<div className="flex items-center justify-between mb-4">
				<h1 className="text-2xl font-bold">Attendees & Hotels</h1>
				<div className="space-x-2">
					<Link to={`/races/${id}`} className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-800 px-3 py-1 rounded">Back to race</Link>
				</div>
			</div>

			<div className="overflow-x-auto bg-white rounded shadow">
				<table className="min-w-full divide-y divide-gray-200">
					<thead className="bg-gray-50">
						<tr>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hotel(s)</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Check-in</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Check-out</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Address</th>
						</tr>
					</thead>
					<tbody className="bg-white divide-y divide-gray-200">
						{[...attendees].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((user, index) => {
							const uHotels = hotelsByUser[user.id] || [];
							const hotelNames = uHotels.length ? uHotels.map(h => h.hotel_name).join('; ') : '-';
							const checkIns = uHotels.length ? uHotels.map(h => formatDate(h.check_in)).join('; ') : '-';
							const checkOuts = uHotels.length ? uHotels.map(h => formatDate(h.check_out)).join('; ') : '-';
							const addresses = uHotels.length ? uHotels.map(h => h.address).join('; ') : '-';

							return (
								<tr key={user.id}>
									<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{index + 1}</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{user.name}</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{hotelNames}</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{checkIns}</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{checkOuts}</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{addresses}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
}
